
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notion",
      function () {
        return require("private-next-pages/notion.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notion"])
      });
    }
  